import type { FC } from 'react'

import { css } from '@emotion/react'

export const Loader: FC = () => {
  return (
    <div
      css={css`
        position: absolute;
        z-index: 100;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 2rem;
        font-weight: 700;
        text-align: center;
        background: rgba(30, 40, 54, 0.9);
        padding: 30px 50px;
        border-radius: 15px;
        border: 2px solid #D72A29;
        backdrop-filter: blur(10px);
        box-shadow: 0 10px 30px rgba(215, 42, 41, 0.3);
        p {
          color: #D72A29;
          margin: 0;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }
      `}
    >
      <p>Loading...</p>
    </div>
  )
}
